module.exports = __webpack_public_path__ + "img/42.3bdb73dc.png";